import React from "react";
import "./index.m.css";

export const SubscriberBand = ({ data }) => {
  if (!data) return null;

  return (
    <div styleName="subscriberBand">
      <div styleName="subscriberCount">{data.count}</div>
      <div styleName="subscriberLabel">{data.label}</div>
    </div>
  );
};
